import { render, staticRenderFns } from "./yc-drug.vue?vue&type=template&id=122ffe58&scoped=true&"
import script from "./yc-drug.vue?vue&type=script&lang=js&"
export * from "./yc-drug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ffe58",
  null
  
)

export default component.exports